export const SEARCH_REQUEST_UPDATE_DATA = 'SEARCH_REQUEST_UPDATE_DATA';
export const SEARCH_REQUEST_SET_TERM = 'SEARCH_REQUEST_SET_TERM';
export const SEARCH_REQUEST_SET_LOCATION = 'SEARCH_REQUEST_SET_LOCATION';
export const SEARCH_REQUEST_UPDATE_TIMES = 'SEARCH_REQUEST_UPDATE_TIMES';

export const updateData = data => {
    return {
        type: SEARCH_REQUEST_UPDATE_DATA,
        payload: data,
    };
};

export const setTerm = ({term, city, destination}) => {
    const termLowerCase = term && term.toLowerCase();

    return {
        type: SEARCH_REQUEST_SET_TERM,
        payload: {
            transient:
                termLowerCase === 'daily' ||
                (termLowerCase !== 'monthly' &&
                    termLowerCase !== 'airport' &&
                    termLowerCase !== 'event'),
            monthly: termLowerCase === 'monthly',
            airport: termLowerCase === 'airport',
            event: termLowerCase === 'event',
            city,
            destination,
        },
    };
};

export const setLocation = ({
    latitude,
    longitude,
    title,
    geolocated = false,
}) => {
    return {
        type: SEARCH_REQUEST_SET_LOCATION,
        payload: {
            latitude,
            longitude,
            title,
            geolocated,
        },
    };
};

export const updateTimes = ({starts, ends, isMonthly}) => {
    return {
        type: SEARCH_REQUEST_UPDATE_TIMES,
        payload: {
            starts,
            ends: isMonthly ? null : ends,
        },
    };
};
